/**
 * This is the twofa controller.
 * @memberOf twofa Module
 * @namespace twofa Controller
 */

/**
 * @name twofaController
 * @desc Create the controller.
 * @param $scope
 * @param coreService
 * @param $state
 * @memberOf twofa Module.twofa Controller
 * @ngInject
 */
function twofaController(coreService, $log, $state) {
  // Assign this controller as the view-model.
  // It will be accessible as 'accountController' within the HTML template.
  var vm = this;

  // Activate the controller.
  activate();

  // Activates the controller.
  function activate() {

    // Read Identity Server's data model & redirect to 2fa setup page or request for code
    var model = coreService.getIdentityModel();

    if(model == null || typeof(model.two_factor_auth_type) === 'undefined' || typeof(model.twofactor_auth_registered) === 'undefined'){
      $state.go('error');
    }

    if (model.twofactor_auth_registered) {
      switch (model.two_factor_auth_type) {
        case 'App':
        case 'ProductApp':
          $state.go('login.2fa.otp');
          break;
        case 'Email':
          $state.go('login.2fa.email');
          break;
        case 'SCE':
            $state.go('login.2fa.sce');
            break;
        case 'Confirmation':
            $state.go('login.2fa.confirmation');
            break;
      }
    }
  }
}

export default twofaController;


// WEBPACK FOOTER //
// ./src/login/2fa/2fa.controller.js